import React from "react";
import { ToastContainer } from "react-toastify";

import SettingsCurrencyDetails from "./components/SettingsCurrencyDetails";

const SettingsCurrencyDetailsApp = (props) => {
  return (
    <>
      <ToastContainer icon={false} />
      <SettingsCurrencyDetails {...props} />
    </>
  );
};

export default SettingsCurrencyDetailsApp;
